import * as React from 'react';
import * as LabelPrimitive from '@radix-ui/react-label';

import { cn } from './cn';
import { Text } from './Typography';

// `first-letter:uppercase` gives labels sentence case without forcing
// the i18n strings themselves to carry the capitalization — keeps the
// JSON values lowercase and composable (e.g. "the {{name}} field is
// required") while the rendered label reads "Name" instead of "name".
// Screen readers read the underlying text, so this is visual-only and
// a11y-neutral for sentence case (the difference between "name" and
// "Name" is imperceptible in speech).
const Label = React.forwardRef(({ children, className: _className, style: _style, disabled = false, required = false, srOnly = false, ...props }, ref) => (
    <LabelPrimitive.Root
        ref={ref}
        className={cn(
            'tw-block tw-text-foreground first-letter:tw-uppercase peer-disabled:tw-cursor-not-allowed peer-disabled:tw-opacity-70',
            disabled && 'tw-opacity-50',
            srOnly && 'tw-sr-only'
        )}
        {...props}
    >
        <Text tone="inherit" variant="control">
            {children}
            {required ? (
                <Text aria-hidden="true" tone="destructive" variant="control"> *</Text>
            ) : null}
        </Text>
    </LabelPrimitive.Root>
));

Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
